import(/* webpackMode: "eager" */ "/root/repo/src/app/(portal)/settings/layout.tsx");
